import React, { useEffect, useState, useRef, useCallback } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
// import Pagination from 'react-bootstrap/Pagination';
import exportIcon from 'assets/img/icons/export.svg';
import { connect } from 'react-redux';
import { CSVLink } from "react-csv";
import Loader from 'features/Loader/Loader';
import moment from 'moment';
import { getClient } from '../../../ducks/clientProfileActions'
import { getNutritionLog, getAllNutritionLog } from '../ducks/nutritionLogsAction';
import { PAGE_SIZE } from '../ducks/types'
import MealsTable from './MealsTable';

import './NutritionHistory.scss';

const NutritionHistory = ({
  getClient,
  getNutritionLog,
  getAllNutritionLog,
  nutritionLogs,
  logs,
  client,
  next,
  previous,
  loadingClient,
  loadingNutritionLog,
  loadingAllNutritionLog,
  ...props
}) => {
  const clientId = props.match.params.client_id;
  const [page, setPage] = useState({pageNumber: 1})
  const [pageHeadStack, setPageHeadStack] = useState({})

  const fileDownload = useRef(null);

  const [, updateState] = React.useState();
  const forceUpdate = useCallback(() => updateState({}), []);

  useEffect(() => {
    if(logs.length > 0)
    download()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logs])

  useEffect(() => {
    getClient(clientId, props.history)
    getNutritionLog(clientId)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClickPrevious = async () => {
    setPage({pageNumber: page.pageNumber - 1})
    getNutritionLog(clientId, pageHeadStack[page.pageNumber - 1], 'previous')
  }

  const handleClickNext = async () => {
    setPageHeadStack({...pageHeadStack, [page.pageNumber]: previous})
    setPage({pageNumber: page.pageNumber + 1})
    getNutritionLog(clientId, next, 'next')
  }

  const handleDownload = async () => {
    getAllNutritionLog(clientId)
  }

  const download = async () => {
    await forceUpdate()
    fileDownload.current.click()
  }

  if(loadingClient || loadingAllNutritionLog || loadingAllNutritionLog) {
    return(<Loader/>);
  }

  return (
    <div className="nutrition-history">
      <div className="history-head">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/">Clients</Breadcrumb.Item>
            <Breadcrumb.Item href={`/clients/${clientId}`}>{`${client?.first_name} ${client?.last_name}`}</Breadcrumb.Item>
            <Breadcrumb.Item active>Nutrition Log History</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <div className="container">
        <div className="page-title">
          <h4>Meal Log History</h4>
          <div className="title-action link-cursor-style">
            <div onClick={handleDownload}>
              <img src={exportIcon} alt="download"/>
            </div>
            <CSVLink
              data={logs}
              filename={`nutrition_summary_${client?.first_name || ''}_${client?.last_name || ''}_${moment().format('MM-DD-YYYY')}.csv`}
            >
              <div ref={fileDownload}></div>
            </CSVLink>
          </div>
        </div>
        <MealsTable nutritionLogs={nutritionLogs}/>

        <div className="page-pagination">
          <button className="nav-last" onClick={handleClickPrevious} disabled={page.pageNumber < 2}>previous</button>
          <button className="nav-last" onClick={handleClickNext} disabled={nutritionLogs.length < PAGE_SIZE}>next</button>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    loadingClient: state.clientProfileReducer.loading,
    nutritionLogs: state.nutritionLogsReducer.nutritionLogs,
    next: state.nutritionLogsReducer.next,
    previous: state.nutritionLogsReducer.previous,
    logs: state.nutritionLogsReducer.logs,
    loadingNutritionLog: state.nutritionLogsReducer.loadingNutritionLog,
    loadingAllNutritionLog: state.nutritionLogsReducer.loadingAllNutritionLog,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getNutritionLog: (clientId, newStart, direction) => dispatch(getNutritionLog(clientId, newStart, direction)),
    getAllNutritionLog: (clientId) => dispatch(getAllNutritionLog(clientId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NutritionHistory);
